module.exports = __webpack_public_path__ + "img/AI_09.544e41c0.png";